import { FaxTypes } from '@frontend/api-fax';
import { useNavigate } from '@frontend/weave-router';

type CloseThreadNavigateArgs = {
  type?: FaxTypes.InboxType;
};

export const useFaxNavigation = () => {
  const navigate = useNavigate();

  const defaultType = FaxTypes.InboxType.INBOX;

  const closeThread = ({ type }: CloseThreadNavigateArgs = {}) => {
    navigate({ to: `/fax/$filter`, params: { filter: type || defaultType }, replace: true });
  };

  return {
    closeThread,
  };
};
